// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"66d87a24e98caec35753","655":"efde93a4ab76f5cb9d44"}[chunkId] + ".js";
};